import React from "react";

type ServiceCardV2Props = {
  icon: string;
  title: string;
  content: string;
};

const ServiceCardV2: React.FC<ServiceCardV2Props> = ({
  icon,
  title,
  content,
}) => {
  return (
    <div
      className="xb-service-card-v2"
      style={{
        minHeight: "320px",          // 🔥 Equal card height
        borderRadius: "16px",
        padding: "35px 28px",
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
        backdropFilter: "blur(10px)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        transition: "0.3s",
      }}
    >
      {/* ICON */}
      <div
        className="icon-wrap"
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "14px",
          background: "rgba(255,255,255,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "18px",
        }}
      >
        <img src={icon} alt="icon" style={{ width: "38px" }} />
      </div>

      {/* TITLE */}
      <h4
        style={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#fff",
          marginBottom: "12px",
          minHeight: "56px", // keeps titles aligned
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {title}
      </h4>

      {/* CONTENT */}
      <p
        style={{
          fontSize: "15px",
          color: "rgba(255,255,255,0.85)",
          lineHeight: "1.6",
        }}
      >
        {content}
      </p>
    </div>
  );
};

export default ServiceCardV2;
